import React, { Component } from "react";
import ReactGA from "react-ga";
import FormTitle from "../FormTitle/FormTitle";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import classes from "./FormSizeOfPlan.module.scss";

import PlanContent from "./PlanContent/PlanContent";

class FormSizeOfPlan extends Component {
  componentDidMount() {
    this.setState({ viewPlan: this.props[ROUTES.PAGE_3_KEY] });
    this.props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_3_KEY]: "",
      // [ROUTES.PAGE_4_KEY]: {},
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
      // benefitSubmit: false
    });
    this.setState((state) => ({ viewPlan: "" }));

    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Size of plan",
        });
      }
    }
    if (this.props.formStyle === "ballpark") {
      this.props.history.push("style-of-plan");
    }
    this.createplans();

    ReactGA.pageview("/size-of-plan");
  }

  state = {
    viewPlan: "",
    planSizeValues: null,
  };

  async createplans() {
    if (this.props.cms) {
      const _planSizeValues = {};
      const cms = this.props.cms;
      cms.forEach((style, index) => {
        let stylename = cms[index].name.toLowerCase();
        _planSizeValues[stylename] = [];

        style.plans.forEach((plan) => {
          _planSizeValues[stylename].push({
            numOfGames: plan.gameNum,
            gameFrequency: plan.sizeDesc,
            priceRange: plan.priceStart,
            avgSavings: plan.sizeAvgSavings,
            concession: plan.sizeConcession,
            numOfSeats: plan.sizeNumOfSeats,
            postSeason: plan.sizePostSeason,
            planChoice: plan.sizePlanChoice,
          });
        });
      });
      // console.log('cms', cms);
      this.setState({ planSizeValues: _planSizeValues });
    }
  }
  onClickSizeOfPlanChoice = (plan) => {
    this.setState((state) => ({ viewPlan: plan, disableSubmit: false }));

    this.props.updateSelectedChoices(ROUTES.PAGE_3_KEY, plan);
  };

  render() {
    if (!this.state.planSizeValues) {
      return <p>Loading ...</p>;
    }
    // console.log('this.state.planSizeValues', this.state.planSizeValues);
    let styleOfPlanSelected = this.state.planSizeValues[
      this.props[ROUTES.PAGE_2_KEY]
    ];

    return (
      <div>
        <div>
          <FormTitle title="Choose the size of your plan" />
          {this.props[ROUTES.PAGE_2_KEY] !== "" ? (
            <>
              <PlanContent
                styleOfPlanSelectedName={this.props[ROUTES.PAGE_2_KEY]}
                styleOfPlanSelected={styleOfPlanSelected}
                sizeOfPlanSelected={this.state.viewPlan}
                onClickSizeOfPlanChoice={this.onClickSizeOfPlanChoice}
              />
              <FormController
                backTo={ROUTES.PAGE_2_LINK}
                nextTo={ROUTES.PAGE_4_LINK}
                startOver={ROUTES.PAGE_1_LINK}
                showBack
                showStartOver
                showSkip={false}
                showSubmit
                submitText="Continue"
                disableSubmit={this.state.viewPlan === ""}
              />
            </>
          ) : (
            <div className={classes.errorMsg}>No Selected Plan Selected</div>
          )}
        </div>
      </div>
    );
  }
}

export default FormSizeOfPlan;
